var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3548_12804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.628033 10.1641C-0.254779 10.668 -0.172748 12.0117 0.768658 12.4024L6.24913 14.6875V18.7227C6.24913 19.4297 6.81944 20 7.52647 20C7.90538 20 8.26475 19.8321 8.50694 19.5391L10.9288 16.6367L15.7687 18.6524C16.5069 18.961 17.3624 18.4766 17.4835 17.6875L19.9835 1.43753C20.0577 0.964871 19.8507 0.488309 19.4562 0.218777C19.0616 -0.050754 18.546 -0.0741915 18.128 0.16409L0.628033 10.1641ZM2.66319 11.1602L16.003 3.53909L7.42491 13.125L7.47178 13.1641L2.66319 11.1602ZM15.753 16.6172L9.24522 13.9024L17.6085 4.55471L15.753 16.6172Z",
    fill: "#FFFCF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3548_12804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/Send2.e68521db.svg";
export { ForwardRef as ReactComponent };